let ENGINE_HTTP_URL, ENGINE_WS_URL, DEFAULT_NETWORK_ID, MIXPANEL_TOKEN, PAIRING_CODE

if (window.env) {
  // ENGINE_HTTP_URL = '/engine'
  // ENGINE_WS_URL = 'ws/engine'
  ENGINE_HTTP_URL = window.env.REACT_APP_ENGINE_HTTP_URL
  ENGINE_WS_URL = window.env.REACT_APP_ENGINE_WS_URL
  DEFAULT_NETWORK_ID = window.env.REACT_APP_DEFAULT_NETWORK_ID
  MIXPANEL_TOKEN = window.env.REACT_APP_MIXPANEL_TOKEN
  PAIRING_CODE = window.env.REACT_APP_PAIRING_CODE
} else {
  ENGINE_HTTP_URL = process.env.REACT_APP_ENGINE_HTTP_URL
  ENGINE_WS_URL = process.env.REACT_APP_ENGINE_WS_URL
  MIXPANEL_TOKEN = '0x'
  DEFAULT_NETWORK_ID = process.env.REACT_APP_DEFAULT_NETWORK_ID || 'default'
  PAIRING_CODE = process.env.REACT_APP_PAIRING_CODE
}

export const MATCHER_FEE = 0.001; // fees must match those on backend side
export const AFFILIATE_FEE = 0.001;
export const MAX_PRICE_PRECISION = 8;

export const GA_ID = process.env.REACT_APP_GA_ID;

export {
  ENGINE_HTTP_URL,
  ENGINE_WS_URL,
  DEFAULT_NETWORK_ID,
  PAIRING_CODE,
  MIXPANEL_TOKEN
}

export const EXCHANGE_ADDRESS = {
  'livenet': 'FVRZTCFXIDQ3EYRGQSLE5AMWUQF4PRYJ', 
  'testnet': 'FVRZTCFXIDQ3EYRGQSLE5AMWUQF4PRYJ',
}[DEFAULT_NETWORK_ID]



// WEBPACK FOOTER //
// ./src/config/environment.js